/* eslint-disable global-require */
// imports aren't the most efficient here

export default [
  {
    name: "Google",
    logo: require("./google.svg"),
    link: "https://cloud.google.com/",
  },
  {
    name: "Netlify",
    logo: require("./netlify.svg"),
    link: "https://www.netlify.com/",
  },
  {
    name: "Gatsby",
    logo: require("./gatsby.svg"),
    link: "https://www.gatsbyjs.org/",
  },
  {
    name: "Slack",
    logo: require("./slack.svg"),
    link: "https://slack.com/",
  },
  {
    name: "Figma",
    logo: require("./figma.svg"),
    link: "https://www.figma.com/",
  },
  {
    name: "Twilio",
    logo: require("./twilio.svg"),
    link: "https://www.twilio.com/",
  },
  {
    name: "Canva",
    logo: require("./canva.svg"),
    link: "https://www.canva.com/",
  },
  {
    name: "Datadog",
    logo: require("./datadog.svg"),
    link: "https://www.datadoghq.com/",
  },
  {
    name: "Algolia",
    logo: require("./algolia.svg"),
    link: "https://www.algolia.com/",
  },
  {
    name: "HermitQA",
    logo: require("./hermit.svg"),
    link: "http://hermitqa.com/",
  },
]
